// import polyfills
import 'core-js/es7/reflect'
import 'zone.js/dist/zone'

// import angular2 dpes
import {platformBrowser} from "@angular/platform-browser";
import {setUpLocationSync} from '@angular/router/upgrade';
import {enableProdMode} from '@angular/core';
import {Sara1AppModule} from './saraV1_app';
import {SaraV2AppModuleNgFactory} from '../../aot/public/upgrade/saraV2_app.ngfactory';

/**
 * We bootstrap the Angular 2 module first, and then, once it's done,
 * bootstrap the Angular 1 module.
 */
if(PRODUCTION_MODE) {
  enableProdMode();
}

platformBrowser().bootstrapModuleFactory(SaraV2AppModuleNgFactory).then(ref => {
  const upgrade = (<any>ref.instance).upgrade;
  upgrade.bootstrap(document.body, [Sara1AppModule.name]);
  setUpLocationSync(upgrade);
});



// WEBPACK FOOTER //
// ./public/upgrade/main.ts